module.exports = __webpack_public_path__ + "assets/assets/images/icons/language.17349420.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/language.svg
// module id = 279
// module chunks = 2